import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import "./WhatsAppChat.css";

const DEFAULT_EMPLOYEES = [
  { id: 1, name: "Rekonic Support", role: "System Admin" },
  { id: 2, name: "Sales Department", role: "Sales Consultant" },
  { id: 3, name: "Accounts & Billing", role: "Accountant" },
];

const PushModal = ({ isOpen, onClose, onPush }) => {
  const [employees, setEmployees] = useState(DEFAULT_EMPLOYEES);
  const [selectedAgent, setSelectedAgent] = useState("");

  useEffect(() => {
    if (isOpen) {
      api.get("/whatsapp/employees")
        .then((res) => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            setEmployees(res.data);
          }
        })
        .catch((err) => console.log("Using fallback employee list:", err));
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedAgent) {
      alert("Please select an agent to reassign the chat.");
      return;
    }
    const agent = employees.find((emp) => emp.name === selectedAgent || `${emp.name} : ${emp.role}` === selectedAgent);
    onPush(agent ? agent.name : selectedAgent);
    setSelectedAgent("");
  };

  return (
    <div className="rekonic-modal-overlay" onClick={onClose}>
      <div className="rekonic-modal-box" onClick={(e) => e.stopPropagation()}>
        <h3 className="rekonic-modal-title">Reassign / Push Chat to Staff</h3>
        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", fontSize: "12px", fontWeight: 600, marginBottom: "6px", color: "#334155" }}>
            Select Rekonic Staff / Agent:
          </label>
          <select
            className="rekonic-modal-input"
            value={selectedAgent}
            onChange={(e) => setSelectedAgent(e.target.value)}
            required
          >
            <option value="">-- Choose Agent --</option>
            {employees.map((emp) => (
              <option key={emp.id} value={emp.name}>
                {emp.name} ({emp.role})
              </option>
            ))}
          </select>

          <div className="rekonic-modal-actions">
            <button type="button" className="rekonic-modal-btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="rekonic-modal-btn-submit">
              PUSH CHAT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PushModal;
